export const SavedFormKeys = {
  avia: {
    key: 'avia',
    value: 'lastHiddenTimeAvia',
  },
  tours: {
    key: 'tours',
    value: 'lastHiddenTimeTours',
  },
} as const

export const SavedFormKeysList = Object.keys(SavedFormKeys)?.map((key) => ({
  value: SavedFormKeys[key as SavedFormKeysTypes].value,
  key: key,
}))

export type SavedFormKeysTypes = keyof typeof SavedFormKeys

export const Minute = 60_000
export const OneWeek = 7 * 24 * 60
export const OneHour = 60

export interface RestoreFormProps<T> {
  key: SavedFormKeysTypes
  duration: number
  setter: (data: T) => void
}
